
import API from './api';
import { fetchData } from './fetch';
/**
 * 获取当前用户的账号版本信息
 * @doc https://docs.google.com/spreadsheets/d/1qUD7k3Dl3FuU_cswVMeaYwIC1efNul1nAIbUswa-1yA/edit#gid=1469618169
*/
export function getAccountPlan() {
    return fetchData(API.GET_ACCOUNT_PLAN.url, API.GET_ACCOUNT_PLAN.type, {});
}